export default __webpack_public_path__ + "static/media/delivery.inline.c44305d4.svg";